module.exports = __webpack_public_path__ + "img/Calculator.3d0c61af.svg";